import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InscricaoAlunoService} from '../inscricao-aluno/inscricao-aluno.service';
import { OrcamentoComponent } from './orcamento.component';
import { MatButtonModule, MatProgressBarModule, MatChipsModule, MatExpansionModule, MatCardModule } from '@angular/material';
@NgModule({
  imports: [
    CommonModule,
    MatButtonModule, MatProgressBarModule, MatChipsModule, MatExpansionModule, MatCardModule
  ],
  declarations: [OrcamentoComponent],
  exports: [OrcamentoComponent],
  providers: [InscricaoAlunoService]
})
export class OrcamentoModule { }
